/**
 * ตัวโหลดหน้า "ออร์เดอร์ของฉัน" — ข้อความ/ขั้นตามเวลาที่รอ (pure · ทดสอบได้)
 * ขั้น: 0 ยืนยันตัวตนกับ LINE (ยังไม่พร้อม) · 1 ดึงออร์เดอร์ · 2 ช้ากว่าปกติ (≥8 วิ) · 3 ช้ามาก (≥15 วิ → ปุ่มลองใหม่)
 */
export const LOADER_SLOW_MS = 8000
export const LOADER_RETRY_MS = 15000

export interface LoaderStage {
  step: 1 | 2 | 3
  pct: number
  title: string
  sub: string
  retry: boolean
}

export function loaderStage(elapsedMs: number, featuresReady: boolean): LoaderStage {
  if (elapsedMs >= LOADER_RETRY_MS) {
    return { step: 3, pct: 90, title: 'โหลดนานกว่าที่ควร', sub: 'ลองใหม่ได้ หรือทักแอดมินให้ช่วยดู', retry: true }
  }
  if (elapsedMs >= LOADER_SLOW_MS) {
    return { step: 3, pct: 82, title: 'ใกล้เสร็จแล้ว ขอบคุณที่รอ', sub: 'ช่วงนี้ระบบช้ากว่าปกติเล็กน้อย', retry: false }
  }
  if (!featuresReady) {
    return { step: 1, pct: 18, title: 'กำลังยืนยันตัวตนกับ LINE', sub: 'ขั้นตอนแรก ใช้เวลาไม่นาน', retry: false }
  }
  return { step: 2, pct: 62, title: 'กำลังดึงออร์เดอร์ของคุณ', sub: 'รวบรวมประวัติบูชาและระดับสมาชิก', retry: false }
}
